import { DatePicker, TimePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { Button, Card, Modal } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { ApiHook } from '../../hooks/apiHook';
import { toast } from 'react-toastify';
dayjs.extend(customParseFormat);

export default function MeetingModal({ data, handleClose }) {
    const addMeetingApi = ApiHook.CallAddMeeting()
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        control,
        reset,
        setValue
    } = useForm();
    const formValues = watch();

    const onSubmit = async (data) => {

        const response = await addMeetingApi.mutateAsync(data)
        if (response.data) {
            reset()
            toast.success("Successful")
            handleClose()
        } else {
            toast.error("Some Error Occured")
        }
    }

    return (
        <>
            <style jsx>{`
                .meeting-card {
                    max-width: 600px;
                    margin: 20px auto;
                    padding: 20px;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }

                .register_form_box {
                    margin-bottom: 20px;
                }

                .register_form_box label {
                    display: block;
                    margin-bottom: 5px;
                    font-weight: 500;
                    color: #333;
                }

                .form-control {
                    width: 100%;
                    padding: 8px 12px;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    font-size: 14px;
                }

                .form-control:focus {
                    outline: none;
                    border-color: #007bff;
                    box-shadow: 0 0 5px rgba(0,123,255,0.3);
                }

                textarea.form-control {
                    min-height: 100px;
                    resize: vertical;
                }

                .error-field {
                    border-color: #dc3545;
                }

                .error-message-validator {
                    color: #dc3545;
                    font-size: 12px;
                    margin-top: 4px;
                    display: block;
                }

                .btn-primary {
                    background-color: #007bff;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 4px;
                    font-weight: 500;
                    transition: background-color 0.2s;
                }

                .btn-primary:hover {
                    background-color: #0056b3;
                }

                .row {
                    display: flex;
                    gap: 15px;
                }

                .col-md-4 {
                    flex: 1;
                }

                .ant-picker {
                    width: 100%;
                    padding: 8px 12px;
                    border-radius: 4px;
                }
            `}</style>

            <Card className="meeting-card">
                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* Rest of your form code remains unchanged */}
                    <div className="regsiter_form_box">
                        <label htmlFor="title">Title</label>
                        <input
                            className={`form-control ${errors.title && 'error-field'}`}
                            {...register("title", { required: true })}
                        />
                        {errors.title && <span className="error-message-validator">required</span>}
                    </div>

                    <div className="regsiter_form_box">
                        <label htmlFor="description">Description</label>
                        <textarea
                            className='form-control'
                            {...register("description")}
                        />
                    </div>

                    <div className="regsiter_form_box">
                        <label htmlFor="link">Link</label>
                        <input
                            className={`form-control ${errors.link && 'error-field'}`}
                            {...register("link", {
                                required: true,
                                pattern: {
                                    value: /https?:\/\/[^\s]+/,
                                    message: "Please enter a valid URL"
                                }
                            })}
                        />
                        {errors.link && <span className="error-message-validator">{errors.link.message || "required"}</span>}
                    </div>

                    <div className="regsiter_form_box">
                        <div className='row'>
                            <label htmlFor="date">Date And Time</label>
                            <div className='col-md-4'>
                                <Controller
                                    name="date"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { onChange, value } }) => (
                                        <>
                                            <DatePicker
                                                value={formValues.date ? dayjs(formValues.date) : null}
                                                onChange={(value, dateString) => {
                                                    setValue("date", dateString)

                                                }}
                                                className={`form-control ${errors.date && 'error-field'}`}
                                                disabledDate={(current) => {
                                                    // Disable all dates before today
                                                    return current && current < dayjs().startOf('day');
                                                }}
                                            />
                                        </>
                                    )}
                                />
                                {errors.date && <span className="error-message-validator">required</span>}
                            </div>
                            <div className='col-md-4'>
                                <Controller
                                    name="startTime"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { onChange, value } }) => (
                                        <>
                                            <TimePicker
                                                value={value ? dayjs(value, 'HH:mm') : null}
                                                onChange={(time, timeString) => {
                                                    onChange(timeString);
                                                    console.log(time, timeString);
                                                    setValue("startTime", timeString)

                                                }}
                                                format="HH:mm"
                                                defaultOpenValue={dayjs('00:00', 'HH:mm')}
                                                className={`form-control ${errors.startTime && 'error-field'}`}
                                                placeholder='start time'
                                            />
                                        </>
                                    )}
                                />
                                {errors.startTime && <span className="error-message-validator">required</span>}
                            </div>
                            <div className='col-md-4'>
                                <Controller
                                    name="endTime"
                                    control={control}
                                    rules={{
                                        // required: true,
                                        validate: value => {
                                            if (!(formValues?.startTime)?.trim() || !(formValues?.endTime)?.trim()) return true; // Skip validation if startTime isn't set
                                            const start = dayjs(formValues.startTime, 'HH:mm');
                                            const end = dayjs(value, 'HH:mm');
                                            return end.isAfter(start) || "End time must be after start time";
                                        }
                                    }}
                                    render={({ field: { onChange, value } }) => (
                                        <>
                                            <TimePicker
                                                value={value ? dayjs(value, 'HH:mm') : null}
                                                onChange={(time, timeString) => {
                                                    onChange(timeString);
                                                    setValue("endTime", timeString)
                                                    console.log(time, timeString);
                                                }}
                                                format="HH:mm"
                                                defaultOpenValue={dayjs('00:00', 'HH:mm')}
                                                className={`form-control ${errors.endTime && 'error-field'}`}
                                                placeholder='end time'
                                            />
                                        </>
                                    )}
                                />
                                {errors.endTime && <span className="error-message-validator">{errors.endTime?.message || "required"}</span>}
                            </div>
                        </div>
                    </div>
                    <div className='text-center'>
                        <button type='submit' className='btn btn-primary'>Finish</button>
                    </div>
                </form>
            </Card>
        </>
    );
}